import React from 'react'
import Navbar from '../components/Navbar'
import Aboutus from '../components/Aboutus'
import NewsLetter from '../components/NewsLetter'
import Footer from '../components/Footer'

export default function AboutUs() {
  return (
    <>
      <Aboutus/>
      <NewsLetter/>
      <Footer/>
    </>
  )
}
